import React, { useState, useCallback, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CContainer,
  CSpinner
} from '@coreui/react';
import { AuthUserContext } from '../../../../session';
import BalanceWidget from '../../CreatorComponents/BalanceWidget';
import RecentPaymentsWidget from '../../CreatorComponents/RecentPaymentsWidget';
import MonthToDateWidget from '../../CreatorComponents/MonthToDateWidget';
import CustomersWidget from '../../CreatorComponents/CustomersWidget';

const CreatorDashboard = (props) => {
  console.log('CreatorDashboard props:', props);
  
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { authUser: contextAuthUser } = useContext(AuthUserContext);
  const { stripeAccountId, authUser: propsAuthUser } = props;

  // Use either the context auth user or the props auth user
  const authUser = propsAuthUser || contextAuthUser;

  console.log('CreatorDashboard mounting:', {
    pathname: location.pathname,
    contextAuthUser,
    propsAuthUser,
    authUser,
    stripeAccountId,
    isLoading,
    allProps: props
  });

  useEffect(() => {
    let mounted = true;

    const initializeDashboard = async () => {
      console.log('Initializing dashboard:', {
        hasStripeId: !!stripeAccountId,
        hasContextAuth: !!contextAuthUser,
        hasPropsAuth: !!propsAuthUser,
        authUser
      });

      // Short timeout to ensure smooth transition
      await new Promise(resolve => setTimeout(resolve, 100));

      if (mounted && stripeAccountId && (propsAuthUser || contextAuthUser)) {
        console.log('Setting loading to false');
        setIsLoading(false);
      }
    };

    initializeDashboard();

    return () => {
      mounted = false;
    };
  }, [authUser, stripeAccountId, contextAuthUser, propsAuthUser]);

  // Show loading state
  if (isLoading) {
    console.log('Dashboard loading state:', { 
      isLoading, 
      stripeAccountId,
      hasContextAuth: !!contextAuthUser,
      hasPropsAuth: !!propsAuthUser
    });
    return (
      <div style={{ 
        padding: '20px', 
        backgroundColor: 'white', 
        margin: '20px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        position: 'relative',
        zIndex: 1000
      }}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <CSpinner style={{ marginBottom: '12px' }} />
          <p style={{ fontSize: '18px', fontWeight: '600' }}>Loading your dashboard...</p>
          <p style={{ fontSize: '14px', color: '#666' }}>
            Status: Initializing dashboard...
          </p>
        </div>
      </div>
    );
  }

  // Get user display name
  const name = authUser?.displayName || 
               authUser?.email?.split('@')[0] || 
               propsAuthUser?.authUser?.displayName ||
               propsAuthUser?.authUser?.email?.split('@')[0] ||
               'Creator';

  console.log('Rendering dashboard content for:', name);

  return (
    <div style={{ 
      padding: '20px', 
      width: '100%',
      position: 'relative',
      zIndex: 1000
    }}>
      <CRow>
        <CCol>
          <CCard style={{ 
            marginBottom: '20px', 
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            position: 'relative',
            zIndex: 1000
          }}>
            <CCardHeader style={{ 
              backgroundColor: '#187da0', 
              color: 'white',
              padding: '20px'
            }}>
              <h1 style={{ margin: 0, fontSize: '24px' }}>Welcome back, {name}!</h1>
            </CCardHeader>
            <CCardBody>
              <div style={{ padding: '16px' }}>
                <h2 style={{ fontSize: '20px', marginBottom: '16px' }}>Dashboard Overview</h2>
                <p style={{ marginBottom: '8px' }}>Your Stripe account ID: <code>{stripeAccountId}</code></p>
                
                {/* Balance Widget */}
                <div style={{ marginBottom: '24px' }}>
                  <BalanceWidget stripeAccountId={stripeAccountId} />
                </div>

                <div style={{ 
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
                  gap: '24px', 
                  marginTop: '24px' 
                }}>
                  {/* Recent Payments Widget */}
                  <div className="dashboard-widget">
                    <RecentPaymentsWidget stripeAccountId={stripeAccountId} />
                  </div>

                  {/* Month to Date Widget */}
                  <div className="dashboard-widget">
                    <MonthToDateWidget stripeAccountId={stripeAccountId} />
                  </div>

                  {/* Customers Widget */}
                  <div className="dashboard-widget">
                    <CustomersWidget stripeAccountId={stripeAccountId} />
                  </div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
};

// Remove withAuthorization HOC temporarily for debugging
export default CreatorDashboard;